export default "__VITE_ASSET__5oLMIswd__"